import { render, staticRenderFns } from "./sendMailApproval.vue?vue&type=template&id=5896c71c&scoped=true&"
import script from "./sendMailApproval.vue?vue&type=script&lang=js&"
export * from "./sendMailApproval.vue?vue&type=script&lang=js&"
import style0 from "./sendMailApproval.vue?vue&type=style&index=0&id=5896c71c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5896c71c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5896c71c')) {
      api.createRecord('5896c71c', component.options)
    } else {
      api.reload('5896c71c', component.options)
    }
    module.hot.accept("./sendMailApproval.vue?vue&type=template&id=5896c71c&scoped=true&", function () {
      api.rerender('5896c71c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpOpsManager/sendMailApproval.vue"
export default component.exports